import DialogComponent from "components/Dialog";

export default class ShiftsDelDialog extends DialogComponent {

    title = "schedule.groupDeletionShifts";

    renderContent() {
        
        return (
            <div className="shiftsDelDialog">
                Групповое удаление смен
            </div>
        );
    }
}
